import { useEffect, useState, useRef } from "react";
import { validateExhibitor } from "../validation";
import { getImageUrl } from "utils/imageHelper";
import { validateImageFile } from "utils/common";
export const useExhibitorForm = (
  initialData,
  selectedOrganizer,
  userId,
  alert,
  setAlert
) => {
  const [existingLogo, setExistingLogo] = useState(null);
  const [existingBanner, setExistingBanner] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    overview: "",
    phone_number: "",
    country_code: "+40",
    email: "",
    password: "",
    country: "",
    website: "",
    manager_name: "",
    manager_email: "",
    exhibitor_category: "",
    status: "active",
    eco_friendly: false,
    logoImage: null,
    bannerImage: null,
    company_id: "",
    created_by: "",
    updated_by: "",
    hallNo: "",
    schedules: [], // Added schedules state
  });

  const [errors, setErrors] = useState({});
  const alertRef = useRef(null);

  useEffect(() => {
    if (initialData) {
      setFormData((prev) => ({
        ...prev,
        ...initialData,
        schedules: initialData.schedules || [], // Populate existing schedules
        logoImage: null,
        bannerImage: null,
        company_id: selectedOrganizer || initialData.company_id || "",
        created_by: initialData.created_by || userId,
        updated_by: userId,
      }));
      setExistingLogo(
        initialData.logo_image ? getImageUrl(initialData.logo_image) : null
      );
      setExistingBanner(
        initialData.banner_image ? getImageUrl(initialData.banner_image) : null
      );
    } else {
      setFormData((prev) => ({
        ...prev,
        company_id: selectedOrganizer || "",
        created_by: userId,
        updated_by: userId,
      }));
    }
  }, [initialData, selectedOrganizer, userId]);

  useEffect(() => {
    if (alert && alertRef.current) {
      alertRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [alert]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log(" name, value", name, value);
    setFormData((p) => ({
      ...p,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Helper setter specifically for updating schedules array
  const setSchedules = (schedules) => {
    setFormData((p) => ({
      ...p,
      schedules:
        typeof schedules === "function" ? schedules(p.schedules) : schedules,
    }));
  };

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    const name = e.target.name;

    if (!file) return;

    let maxMp = 2
    if(name === "bannerImage"){
      maxMp = 5
    }

    const { isValid, error } = await validateImageFile(file, maxMp);

    if (!isValid) {
      setErrors((p) => ({
        ...p,
        [name]: error,
      }));

      return;
    }

    // const allowedTypes = ["image/jpeg", "image/png"];
    // if (!allowedTypes.includes(file.type)) {
    //   setErrors((p) => ({
    //     ...p,
    //     [name]: "Only JPEG and PNG files are allowed",
    //   }));
    //   return;
    // }

    setFormData((p) => ({
      ...p,
      [name]: file,
    }));

    setErrors((p) => ({
      ...p,
      [name]: "",
    }));
  };

  const handleSubmit = (onSubmit) => async (e) => {
    e.preventDefault();

    const validationErrors = validateExhibitor(formData, Boolean(initialData));
    console.log("schedules", formData.schedules);

    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      setAlert("Please fix the highlighted errors");
      return;
    }

    const fd = new FormData();
    Object.entries(formData).forEach(([k, v]) => {
      if (v !== null && v !== undefined) {
        if (k === "schedules") {
          // Serialize schedules array as JSON string for FormData transmission
          fd.append(k, JSON.stringify(v));
        } else if (typeof v === "boolean") {
          fd.append(k, v.toString());
        } else {
          fd.append(k, v);
        }
      }
    });

    setErrors({});
    setAlert("");
    await onSubmit(fd);
  };

  return {
    formData,
    errors,
    handleChange,
    handleFile,
    handleSubmit,
    setSchedules, // Exposed to pass down to ScheduleSection
    existingLogo,
    existingBanner,
  };
};
